module.exports = __webpack_public_path__ + "img/logo-um.f919fed6.svg";